module.exports = __webpack_public_path__ + "static/img/1.0a956df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/gbw/1.jpg
// module id = 92H4
// module chunks = 1